import PRODUCT_COLORS from '../../consts/product/productColors';
import PRODUCT_COLORS_MAPPING from '../../consts/product/productColorsMapping';

const getVariableName = (variableObj) => Object.keys(variableObj)[0];

const getIdentificatorObject = (variableObj) => {
    const identificatorName = getVariableName(variableObj);
    const identificatorValue = variableObj[identificatorName];

    return {
        identificatorName,
        identificatorValue,
    };
};

const getProductIdentificator = (product) => {
    const {codentify, deviceSerialNumber, isP4} = product;
    const identificatorObject =
        isP4 && codentify ? getIdentificatorObject({codentify}) : getIdentificatorObject({deviceSerialNumber});

    return identificatorObject;
};

const findProduct = ({products, isP4, deviceSerialNumber, codentify}) => {
    const {identificatorName, identificatorValue} = getProductIdentificator({
        isP4,
        deviceSerialNumber,
        codentify,
    });

    return products?.find((product) => product[identificatorName] === identificatorValue);
};

const getHexColorByMaterialColor = (type, color) => {
    const productTypeColor = PRODUCT_COLORS_MAPPING[type];

    return productTypeColor?.[color] ? productTypeColor[color] : PRODUCT_COLORS.DEFAULT;
};

const isOriginalCodentifyValid = (codentifyID) => {
    return codentifyID && !codentifyID.includes('*');
};

export default {
    getProductIdentificator,
    findProduct,
    getHexColorByMaterialColor,
    isOriginalCodentifyValid,
};
